import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { inheritSerialization } from 'cerialize';
import { ApprovalRequestSubmission } from './approval-request-submission';

@inheritSerialization(ApprovalRequestSubmission)
export class FeeScheduleApprovalRequestSubmission extends ApprovalRequestSubmission {
  setActive() {
    this.approvalObject.active = true;
  }

  static OnSerialized(instance: FeeScheduleApprovalRequestSubmission, json: any): void {
    if (!isNullOrUndefined(instance?.approvalObject?.effectiveDate)) {
      json.approvalObject.effectiveDate = DateUtil.serializeLocalDate(instance.approvalObject.effectiveDate);
    }
  }
}
